<div [class]="isLoading() ? 'show' : 'hide'" class="no-data-view">Loading...</div>

<div [class]="tableData && tableData.data.length > 0 ? 'show' : 'hide'">
    <table
        mat-table
        [dataSource]="tableData"
        matSort
        matSortActive="startDate"
        matSortDirection="desc"
        multiTemplateDataRows>
        <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="startDate">Start Date</th>
            <td mat-cell *matCellDef="let element">
                {{ element.startDate | date: dateFormat() }}
            </td>
        </ng-container>
        <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="endDate">End Date</th>
            <td mat-cell *matCellDef="let element">
                {{ element.endDate | date: dateFormat() }}
            </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
                {{ element.status }}
            </td>
        </ng-container>
        @for (column of appSpecificColumns(); track column) {
            <ng-container matColumnDef="{{ column.property }}">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.property">{{ column.label }}</th>
                <td mat-cell *matCellDef="let element">
                    {{ element[column.property] }}
                </td>
            </ng-container>
        }
        <ng-container matColumnDef="expandedDetail">
            <td
                mat-cell
                *matCellDef="let element"
                [attr.colspan]="columnsToDisplay().length + appSpecificColumns().length"
                class="expandable">
                <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                    <div class="element-description">
                        @if (appSpecificDetails() && appSpecificDetails().length > 0) {
                            @for (detail of appSpecificDetails(); track $index) {
                                <div class="description-item">
                                    @if (element[detail.property]) {
                                        <strong>{{ detail.label }}: </strong>{{ element[detail.property] }}
                                    }
                                </div>
                            } @empty {
                                <div>No details to display.</div>
                            }
                            @if (appSpecificErrorLinks() && appSpecificErrorLinks().length > 0) {
                                @for (link of appSpecificErrorLinks(); track $index) {
                                    <div class="description-item">
                                        <strong>{{ link.errorType }} Errors: </strong>
                                        <a (click)="expandErrorDetails()" (keyup)="expandErrorDetails()" tabindex="0">{{
                                            link.linkText
                                        }}</a>
                                        <r1-compass-lib-error-table
                                            [ngClass]="!showErrorTable ? 'hide' : 'show'"
                                            [columnsToDisplay]="errorColumnsToDisplay"
                                            [errorData]="errorTableData() ? errorTableData()! : []" />
                                    </div>
                                }
                            }
                            <div class="description-item">
                                <a
                                    (click)="onDownloadSupportDetails(element)"
                                    (keyup)="onDownloadSupportDetails(element)"
                                    tabindex="0"
                                    >Download Support Information</a
                                >
                            </div>
                            <r1-compass-lib-interaction-error-table
                                [interactionErrorTableData]="interactionErrorTableData()" />
                        }
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay()"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay()" (click)="onExpandRow(element)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>

    <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 100]"
        (page)="onPageChange($event)"
        showFirstLastButtons />
</div>

<div [class]="tableData && tableData.data.length === 0 && !isLoading() ? 'show' : 'hide'" class="no-data-view">
    No data for selected date.
</div>
